<template>
  <div>
    <div v-show="mapInitDone" class="map-controls-container">
      <input
        id="gmapsSearchInput"
        class="controls gmaps-input"
        type="text"
        v-model="searchString"
        :placeholder="lang.RCM000"
      />
      <input
        id="gmapsRadiusInput"
        class="controls gmaps-input"
        type="number"
        step="1"
        min="0"
        max="9999"
        v-model.number="currentMapRadius"
        @input="currentMapRadiusChanged()"
      />
      <i class="material-icons md-24 help-icon" id="gmapsHelpIcon">help</i>
      <i
        class="material-icons md-24 search-icon"
        @mousedown.prevent
        @click="searchLocation()"
        >search</i
      >
      <i
        class="material-icons md-24 radius-icon"
        id="gmapsRadiusVisibilityIcon"
        @mousedown.prevent
        @click="changeMapRadiusVisibility()"
        >{{ isMapRadiusVisible ? "radio_button_unchecked" : "block" }}</i
      >
      <b-tooltip
        target="gmapsRadiusInput"
        boundary="viewport"
        triggers="hover"
        :delay="globals.tooltipDelay"
        >{{ lang.RCM001 }}</b-tooltip
      >
      <b-tooltip
        target="gmapsRadiusVisibilityIcon"
        boundary="viewport"
        triggers="hover"
        :delay="globals.tooltipDelay"
        >{{ lang.RCM002 }}</b-tooltip
      >
      <b-tooltip
        target="gmapsHelpIcon"
        boundary="viewport"
        triggers="hover"
        placement="bottomleft"
        :delay="globals.tooltipDelay"
      >
        <div class="tooltip-div">
          <img :src="iconMarkerFactory('shopper').url" height="35" width="35" />
          &rarr; {{ lang.RCM010 }}
        </div>
        <div class="tooltip-div">
          <img
            :src="iconMarkerFactory('NOT_ASSIGNED').url"
            height="35"
            width="35"
          />
          &rarr; {{ lang.RCM013 }}
        </div>
        <div class="tooltip-div">
          <img
            :src="iconMarkerFactory('ASSIGNED_NO_ANSWER').url"
            height="35"
            width="35"
          />
          &rarr; {{ lang.RCM011 }}
        </div>
        <div class="tooltip-div">
          <img
            :src="iconMarkerFactory('ASSIGNED_WITH_ANSWER').url"
            height="35"
            width="35"
          />
          &rarr; {{ lang.RCM012 }}
        </div>
      </b-tooltip>
    </div>
    <div id="gmaps-container"></div>
  </div>
</template>

<script>
import globals from "./../../globals";

window.gmapsInfoWindowMarkerButtonClicked = function (type, guid) {
  let data = { type: type, guid: guid };
  globals.$emit("gmapsInfoWindowMarkerButtonClicked", data);
};

export default {
  name: "GoogleMaps",
  props: {
    currentFilterObject: {
      Type: Object,
      default: () => ({}),
    },
    checkList: {
      type: Array,
      default: () => [],
    },
    shopperList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      geocoder: null,
      map: null,
      mapInitDone: false,
      searchString: "",
      currentMapRadius: 50,
      isMapRadiusVisible: false,
      location: "Deutschland",
      currentPosition: null,
      icons: {
        ASSIGNED_NO_ANSWER: { icon: "ylw-circle.png" },
        ASSIGNED_WITH_ANSWER: { icon: "orange-circle.png" },
        NOT_ASSIGNED: { icon: "grn-circle.png" },
        shopper: { icon: "blu-stars.png" },
      },
      mapOptions: {
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: true,
        scaleControl: true,
        rotateControl: false,
        disableDefaultUi: false,
        mapTypeId: "roadmap",
      },
      checkMarkers: [],
      shopperMarkers: [],
      currentMapCircle: null,
      selectedMarker: null,
      searchBox: null,
      lang: {
        RCM000: "Search",
        RCM001: "Radius in km",
        RCM002: "Switch radius visibility",
        RCM003: "Filter for this check",
        RCM004: "Filter for this shopper",
        RCM005: "Wave",
        RCM006: "Gender",
        RCM007: "Age",
        RCM008: "male",
        RCM009: "female",
        RCM010: "Shopper",
        RCM011: "Check assigned but not yet edited",
        RCM012: "Check assigned and edited",
        RCM013: "Check not assigned",
        RCM014: "Remove filter",
        RCM015: "Scenario",
        RCM016: "Vehicle",
        RCM017: "Target model",
        RCM018: "Approved shopper",
      },
    };
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    if (!window.google) {
      this.globals.$once("googleInitDone", () => {
        this.initGoogleMap();
      });
    } else {
      this.initGoogleMap();
    }
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    isMapRadiusVisible(newVal) {
      if (newVal) $(".btn-marker-info").removeClass("hidden");
      else {
        let button = $(".btn-marker-info");
        button.addClass("hidden");
        button.removeClass("btn-warning");
        button.html(this.lang.RCM003);
      }
    },
  },
  methods: {
    initGoogleMap() {
      let currentPosition = { lat: 51, lng: 10.5 };

      const init = () => {
        this.mapOptions.center = new google.maps.LatLng(
          currentPosition.lat,
          currentPosition.lng
        );
        this.mapOptions.zoom = 6;

        this.map = new google.maps.Map(
          document.getElementById("gmaps-container"),
          this.mapOptions
        );
        this.map.infowindow = new google.maps.InfoWindow();

        let input = document.getElementById("gmapsSearchInput");
        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
        let radiusInput = document.getElementById("gmapsRadiusInput");
        this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
          radiusInput
        );

        this.searchBox = new google.maps.places.SearchBox(input);
        this.searchBox.addListener("places_changed", this.searchLocation);

        this.geocoder = new google.maps.Geocoder();

        google.maps.event.addListenerOnce(this.map, "tilesloaded", () => {
          this.mapInitDone = true;
        });
      };

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          currentPosition = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
          init();
        },
        (error) => {
          console.error(error);
          init();
        }
      );

      this.globals.$off("gmapsInfoWindowMarkerButtonClicked");
      this.globals.$on("gmapsInfoWindowMarkerButtonClicked", (data) => {
        let button = $(`#gmapsInfoWindowMarkerButton-${data.guid}`);
        if (button) {
          if (this.currentFilterObject.RadiusSurveyInstanceGuid === data.guid) {
            button.removeClass("btn-warning");
            button.html(this.lang.RCM003);
            data.state = false;
          } else {
            button.addClass("btn-warning");
            button.html(this.lang.RCM014);
            data.state = true;
          }
        }
        this.$emit("markerInfoSelectButtonClicked", data);
      });
    },
    iconMarkerFactory(type = "NOT_ASSIGNED", size = { width: 50, height: 50 }) {
      const iconBaseUrl = "https://maps.google.com/mapfiles/kml/paddle/";
      let url = `${iconBaseUrl}${this.icons[type].icon}`;
      let scaledSize = size;
      return { url, scaledSize };
    },
    zoomToLocation(formatted_address) {
      this.geocoder.geocode(
        { address: formatted_address },
        (results, status) => {
          if (status !== "OK" || !results[0]) {
            throw new Error(status);
          }
          this.map.setCenter(results[0].geometry.location);
          this.map.fitBounds(results[0].geometry.viewport);
        }
      );
    },
    searchLocation() {
      let location = this.searchBox.getPlaces(); //TODO: does not work if location in searchbox was selected before
      if (location) this.zoomToLocation(location[0].formatted_address);
      else {
        if (!this.searchString) return;
        this.geocoder.geocode(
          { address: this.searchString },
          (results, status) => {
            if (status !== "OK" || !results[0]) {
              throw new Error(status);
            }
            this.zoomToLocation(results[0].formatted_address);
          }
        );
      }
    },
    currentMapRadiusChanged() {
      if (this.currentMapRadius < 0) this.currentMapRadius = 0;
      else if (this.currentMapRadius > 9999) this.currentMapRadius = 9999;
      this.drawMarkerCircle(this.selectedMarker);
      this.emitRadiusData();
    },
    changeMapRadiusVisibility() {
      this.isMapRadiusVisible = !this.isMapRadiusVisible;
      this.drawMarkerCircle(this.selectedMarker);
      this.emitRadiusData();
    },
    emitRadiusData() {
      let radiusData = {
        visible: this.isMapRadiusVisible,
        radius: this.currentMapRadius,
      };
      this.$emit("mapRadiusChanged", radiusData);
    },
    showChecksOnMap() {
      this.clearCheckMarkers();

      this.checkList.forEach((check) => {
        if (!check.Location) return;
        let location = {
          lng: check.Location.Longitude,
          lat: check.Location.Latitude,
        };

        let infotext = `<div style="text-align: left;">
          <b>Check ID: ${check.SurveyInstanceId}</b>
          <br>
          <br>${check.LocationName}
          <br>
          <br>${check.LocationAddress}
          <br>${check.LocationPostalCode} ${check.LocationCity}
          <br>
          <br>${this.lang.RCM005}: ${check.WaveName}
          <br>${this.lang.RCM015}: ${check.ScenarioName}`;

        if (check.ApprovedShopperName)
          infotext += `<br>
          <br>${this.lang.RCM018}:
          <br>${check.ApprovedShopperName}`;

        infotext += `<br><button class="btn btn-raised btn-success btn-marker-info hidden" 
            id="gmapsInfoWindowMarkerButton-${check.SurveyInstanceGuid}" 
            onclick="gmapsInfoWindowMarkerButtonClicked('check','${check.SurveyInstanceGuid}')">${this.lang.RCM003}</button>
          </div>`;

        const marker = new google.maps.Marker({
          position: location,
          map: this.map,
          icon: this.iconMarkerFactory(check.SurveyInstanceRecruitingStatus),
          infotext: infotext,
        });
        marker.addListener("click", () => {
          this.showMarkerInfo(marker);
          this.drawMarkerCircle(marker);
          this.selectedMarker = marker;
          this.$nextTick(() => {
            let button = $(
              `#gmapsInfoWindowMarkerButton-${check.SurveyInstanceGuid}`
            );
            if (this.isMapRadiusVisible) button.removeClass("hidden");
            if (
              check.SurveyInstanceGuid ===
              this.currentFilterObject.RadiusSurveyInstanceGuid
            ) {
              button.addClass("btn-warning");
              button.html(this.lang.RCM014);
            }
          });
        });
        this.checkMarkers.push(marker);
      });
    },
    showShoppersOnMap() {
      this.clearShopperMarkers();

      this.shopperList.forEach((shopper) => {
        if (!shopper.Location) return;
        let location = {
          lng: shopper.Location.Longitude,
          lat: shopper.Location.Latitude,
        };
        let infotext = `<div style="text-align: left;">
          <b>${shopper.FirstName} ${shopper.LastName} (${shopper.Username})</b>
          <br>
          <br>${this.lang.RCM006}: ${
          shopper.Gender === "F" ? this.lang.RCM009 : this.lang.RCM008
        }
          <br>${this.lang.RCM007}: ${shopper.Age}
          <br>Ort: ${shopper.City}`;

        if (shopper.AudiShopperInfos)
          for (let i = 0; i < shopper.AudiShopperInfos.length; i++) {
            infotext += `
          <br>
          <br><b>${this.lang.RCM016} ${i + 1}</b>: ${
              shopper.AudiShopperInfos[i].ShopperCar
            }
          <br>${this.lang.RCM017}: ${
              shopper.AudiShopperInfos[i].CarModelName
            } (${shopper.AudiShopperInfos[i].CarMatch})
          `;
          }

        infotext += `<br><button class="btn btn-raised btn-success btn-marker-info hidden"
            id="gmapsInfoWindowMarkerButton-${shopper.ShopperGuid}"
            onclick="gmapsInfoWindowMarkerButtonClicked('shopper','${shopper.ShopperGuid}')">${this.lang.RCM004}</button>
        </div>`;
        const marker = new google.maps.Marker({
          position: location,
          map: this.map,
          icon: this.iconMarkerFactory("shopper"),
          infotext: infotext,
        });
        marker.addListener("click", () => {
          this.showMarkerInfo(marker);
          this.drawMarkerCircle(marker);
          this.selectedMarker = marker;
        });
        this.shopperMarkers.push(marker);
      });
    },
    showMarkerInfo(marker) {
      this.map.infowindow.setContent(marker.infotext);
      this.map.infowindow.open(this.map, marker);
    },
    drawMarkerCircle(marker) {
      if (this.currentMapCircle) this.currentMapCircle.setMap(null); // Remove old circle
      if (!marker || !this.isMapRadiusVisible) return;

      this.currentMapCircle = new google.maps.Circle({
        map: this.map,
        radius: this.currentMapRadius * 1000,
        fillColor: "#990000",
      });
      this.currentMapCircle.bindTo("center", marker, "position");
    },
    clearCheckMarkers() {
      this.checkMarkers.forEach((marker) => {
        marker.setMap(null);
      });
      this.checkMarkers = [];
    },
    clearShopperMarkers() {
      this.shopperMarkers.forEach((marker) => {
        marker.setMap(null);
      });
      this.shopperMarkers = [];
      this.selectedMarker = null;
    },
  },
};
</script>

<style>
.btn-marker-info {
  height: 26px;
  margin: 10px 0 0 0;
  padding: 0 20px 0 20px;
  box-shadow: none !important;
}
</style>

<style scoped>
#gmaps-container {
  height: calc(100vh - 80px);
  margin: 0;
  padding: 0;
}

.gmaps-input {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin: 5px;
  padding: 0 32px 0 10px;
  text-overflow: ellipsis;
  width: 30%;
  border: 1px solid #ccc;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  line-height: 30px;
}
.gmaps-input:focus {
  border-color: #4d90fe;
}
#gmapsRadiusInput {
  width: 120px;
}

.map-controls-container > i {
  position: absolute;
  top: 9px;
  cursor: pointer;
  border-left: 1px solid lightgray;
  padding-left: 3px;
  z-index: 10;
}
.search-icon {
  left: calc(30% - 28px);
}
.radius-icon {
  right: 10px;
  color: #bb0000;
}
.help-icon {
  top: 45px !important;
  right: 10px;
  bottom: 10px !important;
  border-left: none !important;
  color: var(--color-primary-input);
  height: 25px;
}
.tooltip-div {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// GoogleMaps.vue?1447f672